import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HOME_DATA } from '../home/home.data';
import { ABOUT_DATA } from './about.data';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-about',
  standalone: true,
  imports: [TranslateModule, RouterOutlet, CommonModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent extends BaseComponent {
  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
  public HOME_DATA = HOME_DATA;
  public ABOUT_DATA = ABOUT_DATA;
}
